import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { Button } from "antd";
import "./index.less";

interface IProps extends RouteComponentProps {
}
const BackToPreviousPage = (props:IProps) => {
    const back = () => {
        props.history.go(-1);
    };
    return <Button className="btn-back" onClick={back}><i className="iconfont icon-chevron-left"></i>BACK</Button>
};
export default withRouter(BackToPreviousPage);
